import { render, staticRenderFns } from "./LoadingChartCard.vue?vue&type=template&id=922fc79c&scoped=true&"
import script from "./LoadingChartCard.vue?vue&type=script&lang=js&"
export * from "./LoadingChartCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922fc79c",
  null
  
)

export default component.exports